import { fetcher } from '@commenda/utils';

import { TUpdateBillingBundleParams } from './types';

export const updateBillingBundle = async (bundleId: string, params: TUpdateBillingBundleParams) => {
  const response = await fetcher(`commenda-billing/catalog/bundles/${bundleId}`, {
    method: 'PATCH',
    body: params,
  });

  return response;
};
